import { HARDWARE_CHECKOUT_ALLOWED_COUNTRIES } from "@screencloud/billing-client-api";

/**
 * Supported hardware shipping destinations.
 *
 * @remarks
 * Single source of truth is {@link HARDWARE_CHECKOUT_ALLOWED_COUNTRIES} (the
 * checkout allow-list from the billing client), so the deal country dropdown and
 * this address-form check can never disagree.
 */
export const SUPPORTED_SHIPPING_COUNTRIES: readonly string[] =
  HARDWARE_CHECKOUT_ALLOWED_COUNTRIES;

/**
 * Whether hardware can be shipped to the given country.
 *
 * An empty/unknown country code is treated as not-yet-supported so the UI does
 * not prematurely show the unsupported-country warning before a country is
 * chosen — callers should guard on a non-empty code where relevant.
 */
export const isShippingSupported = (countryCode: string | undefined): boolean =>
  !!countryCode && SUPPORTED_SHIPPING_COUNTRIES.includes(countryCode);
